// @ts-nocheck
import React, { useEffect, useState } from "react";
import "../../styles/delivery.css";
import {
  deliveryFunction,
  deliveryRussiaFunction,
  paymentFunction,
  selfExportFunction,
} from "js/deliveryBackend";
import Seo from 'components/Seo';
import deliveryInfo from "../../assets/icons/delivery-info.svg";
import { useStores } from "hooks/useStores";

const DeliveryPage = () => {
  const [mainItems, setMainItems] = useState({});
  const [contacts, setContacts] = useState({});

  const { api } = useStores();


  useEffect(() => {
    api.content.getPageApi("delivery")
      .then((response) => {
      if (response) {
        setContacts(response.init_state.contacts);
        paymentFunction(response.init_state.payment);
        setMainItems(response.init_state.object);
        selfExportFunction(response.init_state["self-export"]);
        deliveryFunction(response.init_state.delivery);
        deliveryRussiaFunction(response.init_state["delivery-in-russia"]);
      }
    })
  }, []);

  const deliveryJsonLd = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": mainItems?.seo_title || "Доставка",
    "description": mainItems?.seo_description || "Информация о доставке компании Пак Пакыч",
    "url": window.location.href
  };

  return (
    <>
      <Seo seo={mainItems} />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(deliveryJsonLd) }}
      />
      <main id='deliveryPage'>
        <section className='section-delivery delivery'>
          <div className='delivery-wrap'>
            <div className='delivery-info'>
              <h2 className='title'>1.Доставка</h2>
              <div className='subtitle'></div>
              <div className='title-descr'></div>
              <div className='info-wrap'>
                <img loading="lazy" src={deliveryInfo} alt='Delivery Info' />
                <p className='title-info'>
                  {" "}
                  При отсутствии свободного лимита и размещении заказа после
                  15:00 доставка осуществляется через один рабочий день.
                </p>
              </div>
            </div>
            <div className='delivery-card'>
              <div className='delivery-card__item'></div>
              <div className='delivery-card__item'></div>
              <div className='delivery-card__item'></div>
              <div className='delivery-card__item-gold'>
                <div className='delivery-gold-wrap'></div>
              </div>
            </div>
            <div className='delivery-regions'></div>
            <div className='delivery-pickup'></div>
            <div className='delivery-pickup__info'>
              <div className='pickup-info'>
                <div className='pickup-adress'></div>
                <div className='pickup-hours'></div>
                <ul className='pickup-cards__list'>
                  <li className='pickup-cards'>
                    <img loading="lazy"
                      className='pickup-cards-image'
                      src='../assets/icons/pickup-pass.svg'
                      alt='Pickup Pass'
                    />
                    <div className='pickup-cards__info'>
                      <p className='cards-title'></p>
                      <p className='cards-descr'></p>
                    </div>
                  </li>
                  <li className='pickup-cards'>
                    <img loading="lazy"
                      className='pickup-cards-image'
                      src='../assets/icons/pickup-pass.svg'
                      alt='Pickup Pass'
                    />
                    <div className='pickup-cards__info'>
                      <p className='cards-title'>Для получения товара:</p>
                      <p className='cards-descr'>
                        Необходимо предоставить доверенность
                        <span className='cards-gray'>по</span>
                        <br />
                        <span className='cards-gray'>форме М-2</span>
                        или иметь при себе круглую печать
                        <br />
                        организации на сопроводительные документы
                      </p>
                    </div>
                  </li>
                </ul>
              </div>
              <div className='pickup-map'>
                <iframe
                  className='map'
                  frameBorder={0}
                  title='map'
                  src={contacts.driving_scheme_url}
                ></iframe>
              </div>
            </div>
          </div>
        </section>
        <section className='section-delivery delivery-payment'>
          <div className='delivery-wrap'>
            <div className='payment-heading-js'></div>
            <div className='payment-cards'>
              <div className='payment-cards-top'>
                <div className='payment-cards__item'>
                  <img loading="lazy" className='payment-cards-image' src='' alt='Order' />
                  <div className='payment-cards__info'></div>
                </div>
                <div className='payment-cards__item'>
                  <img loading="lazy" className='payment-cards-image' src='' alt='Matching' />
                  <div className='payment-cards__info'></div>
                </div>
                <div className='payment-cards__item'>
                  <img loading="lazy" className='payment-cards-image' src='' alt='Account' />
                  <div className='payment-cards__info'></div>
                </div>
              </div>
              <div className='payment-cards-bot'>
                <div className='payment-cards__item'>
                  <img loading="lazy" className='payment-cards-image' src='' alt='Payment' />
                  <div className='payment-cards__info'></div>
                </div>
                <div className='payment-cards__item'>
                  <img loading="lazy" className='payment-cards-image' src='' alt='Shipment' />
                  <div className='payment-cards__info'></div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
    </>
  );
};

export default DeliveryPage;
